// extracted by mini-css-extract-plugin
export default {"main":"home_main__Z8ds3","video_intro":"home_video_intro__4eKYB","optional_img":"home_optional_img__7lerf","content":"home_content__No7q+","overlay":"home_overlay__cjDhd"};